import {AfterViewInit, Component, inject} from '@angular/core';
import {DoctorsService} from "@services/doctors/doctors.service";
import {RouterOutlet} from "@angular/router";

@Component({
  selector: 'app-doctors',
  imports: [
    RouterOutlet,
  ],
  templateUrl: './doctors.component.html',
  standalone: true,
  styleUrl: './doctors.component.scss'
})
export class DoctorsComponent implements AfterViewInit {

  private doctorsService = inject(DoctorsService);

  doctors?: any[];
  patients?: any;

  ngAfterViewInit() {
    console.log('DoctorsComponent initialized');
    this.doctorsService.fetchDoctors()
      .subscribe((data: any) => {
        this.doctors = data;
        this.doctorsService.resetDoctorsList(data);
      });
  }

  goBack() {

  }

  openDoctor(doctor: any) {

  }
}
